var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data"},[_vm._t("breadcrumbsWrp",null,{"item":_vm.dataForTesting}),_vm._v(" "+_vm._s(_vm.actualView.name)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }